import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, makeApiReducer, ApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';


const KEY_ACTION = ActionType.GetECourseDisplayNameRequest;
const ACTIONS    = [
  ActionType.GetECourseDisplayNameRequest,
  ActionType.GetECourseDisplayNameResponse,
  ActionType.GetECourseDisplayNameError,
];


type Payload = string;


type Meta = {
  projectId: number;
};


/**
 * Dispatch this action to retrieve the contact details for the participant's current project
 *
 * @param projectId - the database Id of the project whose contact info we want
*/
export const getECourseDisplayNameAction = (
  projectId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.GetECourseDisplayName,
    headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
    body:     JSON.stringify({
      projectId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { projectId } = action.meta;
  const metaTag       = `${projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assoc('eCourseDisplayName', payload, successState);
};

export const getECourseDisplayNameReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
